module.exports = __webpack_public_path__ + "img/module2-01.e3045567.jpg";